import { colunasCustom } from './campos';
import React from 'react';
import { LEAD_ORIGINS, STAGES } from './constantes';
import { calcContractTotal } from './formato';
import { diasNaEtapa, tempoPrimeiroContato } from './pipeline';

function baixarCSV(nome, linhas) {
  if (!linhas?.length) { alert('Nada para exportar.'); return; }
  const colunas = Object.keys(linhas[0]);
  const escapa = (v) => {
    const t = v === null || v === undefined ? '' : String(v);
    return /[";\n]/.test(t) ? '"' + t.replace(/"/g, '""') + '"' : t;
  };
  const csv = [
    colunas.join(';'),
    ...linhas.map(l => colunas.map(c => escapa(l[c])).join(';')),
  ].join('\r\n');
  // BOM para o Excel abrir acentuação certa
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `${nome}-${new Date().toISOString().slice(0,10)}.csv`;
  document.body.appendChild(a); a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

/** Achata um lead para linha de planilha. */

function leadParaLinha(l, camposCustom = []) {
  const etapa = STAGES.find(x => x.key === l.stage);
  const origem = LEAD_ORIGINS.find(x => x.key === l.origem);
  const ptc = tempoPrimeiroContato(l);
  return {
    Empresa: l.company_name || '',
    Contato: l.contact_name || '',
    Telefone: l.contact_phone || '',
    Site: l.site || '',
    Instagram: l.instagram ? '@' + l.instagram : '',
    'E-mail': l.contact_email || '',
    Etapa: etapa?.label || l.stage || '',
    'Valor mensal': Number(l.value) || 0,
    Recorrencia: l.recurrence || '',
    'Valor contrato': calcContractTotal(l.value, l.recurrence),
    'Variavel %': l.variable_rate || 0,
    Servico: l.service_type || '',
    Origem: origem?.label || l.origem || '',
    Vendedor: l.seller_name || '',
    Parceiros: (l.partners || []).map(x => x.name).join(' + '),
    Temperatura: l.temperature || '',
    'Dias na etapa': diasNaEtapa(l) ?? '',
    'Horas ate 1o contato': ptc ?? '',
    'Proxima abordagem': l.next_contact_date || '',
    'Repetir a cada (dias)': l.followup_days || '',
    'Previsao fechamento': l.forecast_date || '',
    'Probabilidade %': l.forecast_prob ?? '',
    Proposta: l.proposal_url || '',
    'Motivo da perda': l.loss_reason || '',
    Interacoes: (l.interactions || []).length,
    Criado: l.created_at ? l.created_at.slice(0,10) : '',
    Atualizado: l.updated_at ? l.updated_at.slice(0,10) : '',
    ...colunasCustom(camposCustom, l),
  };
}

// ─── C-33: negociação esfriando ───────────────────────────
// Limite por etapa, em dias. Etapa mais quente tolera menos parada.

export { baixarCSV, leadParaLinha };
